import React, { ReactNode } from "react";
import styled, { useTheme } from "styled-components";
import { newLookPanel } from "features/settings/CancelSubscription/styles.tsx";
import useMedia from "utils/hooks/useMedia.ts";
import { VERTICAL_LAYOUT_MIN_WIDTH } from "features/settings/CancelSubscription/constants.ts";

interface PageLayoutProps {
  topContainer: ReactNode;
  Icon: (props: any) => React.JSX.Element;
  mainContent: ReactNode;
}

const PageLayout = ({ topContainer, Icon, mainContent }: PageLayoutProps) => {
  const isMobile = useMedia(
    [`(max-width: ${VERTICAL_LAYOUT_MIN_WIDTH}px)`],
    [true],
    false
  );

  const { isNewLook } = useTheme();

  // New look: one quiet card, no large illustration.
  if (isNewLook) {
    return (
      <NewLookPanel>
        {topContainer}
        {mainContent}
      </NewLookPanel>
    );
  }

  if (isMobile) {
    return (
      <Wrapper>
        <ImageWrapper>
          <Icon $size="200px" />
        </ImageWrapper>
        {topContainer}
        {mainContent}
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {topContainer}
      <ContentWrapper>
        {mainContent}
        <ImageWrapper>
          <Icon $size="350px" />
        </ImageWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};

export default PageLayout;

const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;
const ContentWrapper = styled.div`
  display: flex;
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
`;
const NewLookPanel = styled.div`
  ${newLookPanel}
`;
